import { kfzInputClientEntityDehydrationDefinitions } from '@/features/Sparten/shared/clientDehydration/kfz/conditionalClientRequestDefinitions';
import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { computed } from 'vue';
import { KfzFahrerResource } from '@/features/Sparten/shared/schema/kfz/clientSchema/clientSchema';

/**
 * V2-Delta gegenüber pkw v1 (das die shared Liste unverändert nutzt): das VN-Bool
 * `hasAnSicherheitstrainingTeilgenommen` je Fahrer wird in V2 nicht mehr gesendet — es ist
 * durch das VN-Datumsfeld `anSicherheitstrainingTeilnahmedatum` ersetzt. Alle übrigen
 * pkw-Fahrerfelder (hasAnBegleitetenFahrenTeilgenommen, Jahreskarte, Wohneigentum) bleiben.
 */
const nonAvailableFields: ConditionalRequestDefinition = {
  if: computed(() => true),
  drop: ['meta.hasAnSicherheitstrainingTeilgenommen'],
};

export const clientInputDehydration: ConditionalRequestDefinition<KfzFahrerResource>[] =
  [...kfzInputClientEntityDehydrationDefinitions, nonAvailableFields];
